import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunityinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M14.588 2.889a3.667 3.667 0 1 1-5.186 5.186 3.667 3.667 0 0 1 5.186-5.186M21.225 14.383a3.661 3.661 0 1 1-5.178 5.178 3.661 3.661 0 0 1 5.178-5.178M7.953 14.383a3.661 3.661 0 1 1-5.178 5.178 3.661 3.661 0 0 1 5.178-5.178"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M17.419 7.727A7.663 7.663 0 1 1 6.582 18.564 7.663 7.663 0 0 1 17.419 7.727"
	})]
});
export default SvgCommunityinline;
